import { useAppSelector } from "../../app/hooks";
import { useMousePosition } from "../../app/useMousePosition";

interface Props {
	className?: string;
}

export default function LineReader(props: Props) {
	const accessibility = useAppSelector((state) => state.user.accessibility);
	if (!accessibility?.lineReader) return null;

	return <LineReaderImpl {...props} />;
}

function LineReaderImpl(props: Props) {
	const position = useMousePosition();

	const viewportHeight = 60;
	const viewportTop = position.y - viewportHeight / 2;
	const viewportBottom = position.y + viewportHeight / 2;

	return (
		<>
			<div
				className={`${props.className} line-reader fixed top-0 left-0 w-screen opacity-70 pointer-events-none bg-black`}
				style={{
					height: viewportTop,
				}}></div>
			<div
				className={`${props.className} line-reader fixed bottom-0 left-0 w-screen opacity-70 pointer-events-none bg-black`}
				style={{
					top: viewportBottom,
				}}></div>
		</>
	);
}
